import React from 'react';
export function SiteFooter() {
  return <footer className="mt-16 w-full border-t border-ink/10 bg-ink text-paper/80" data-id="element-338">
      <div className="mx-auto max-w-3xl px-5 py-10" data-id="element-339">
        <p className="mb-4 text-center font-display text-xl font-bold text-paper" data-id="element-340">
          Réveil
        </p>
        <p className="text-xs leading-relaxed text-paper/60" data-id="element-341">
          This is a paid promotion by Réveil. Rachel Adler is a composite
          character whose story represents the collective experience of former
          aesthetic industry professionals who contributed to Réveil's
          development. Their real identities have been protected to shield them
          from professional retaliation. Testimonial names and identifying
          details have been changed for the same reason. Réveil is a
          personal-use device intended to support the appearance of facial
          firmness and definition. It is not a medical treatment. Individual
          results vary.
        </p>
        <p className="mt-6 text-center text-xs text-paper/40" data-id="element-342">
          © {new Date().getFullYear()} Réveil. All rights reserved.
        </p>
      </div>
    </footer>;
}